export default {
  sections: {
    state: {
      title: 'Stan',
      fields: {
        pickup_visible: {
          label: 'Odbiór widoczny',
        },
        has_pickup: {
          label: 'Odbiór',
        },
      },
    },
    scheduled_orders: {
      title: 'Zamówienia zaplanowane',
      fields: {
        has_scheduled_orders: {
          label: 'Czy klienci mogą zamawiać z wyprzedzeniem na określone godziny?',
        },
        min_schedule_ahead_time_pickup: {
          label: 'Minimalny czas (minuty) z wyprzedzeniem przy planowaniu zamówień <strong>na odbiór</strong>',
          placeholder: '30',
        },
        last_order_gap_pickup: {
          label: 'Ostatni możliwy czas zamówienia <strong>na odbiór</strong> (minuty przed zamknięciem)',
          option: '{{value}} min',
        },
      },
    },
    preparation_time_pickup_orders: {
      title: 'Czas przygotowania zamówień na odbiór',
      fields: {
        average_order_preparation_time_min: {
          label: 'Czas przygotowania w minutach',
          placeholder: '20',
        },
        average_order_preparation_time_max: {
          label: 'do',
          placeholder: 'Opcjonalnie',
        },
      },
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    at_least_one_order_method_required:
      'Co najmniej 1 metoda zamówienia (zaplanowane lub natychmiast) musi być włączona. Nie można wyłączyć obu.',
  },
};
